import React, { useContext, useEffect, useState } from "react";
import { AppContext } from "../../App";
import { useTranslation } from "react-i18next";
import { DynamicTable } from "../../layout";
import { action, controller } from "../../api/Server";
import { formatDate } from "../../hooks/Method";
import { TableCell } from "@mui/material";
import dayjs from "dayjs";

const SalesByCustomer = () => {
  const { t } = useTranslation();
  const { settings, setPageTitle, pageTitle } = useContext(AppContext);
  const [reports, setReports] = useState([]);
  const [tblData, setTblData] = useState([]);
  const [result, setResult] = useState({});

  useEffect(() => {
    setPageTitle(t("salesByCustomer"));

    setTblData([
      ...reports.map((s) => ({
        customer: (
          <div className="d-grid gap-2 link">
            <span>
              {s.customerName} | ID: {s.customerId}
            </span>
            <span className="fs-12 fw-5">
              Last Txn Date: {formatDate(s.lastSaleDate)}
            </span>
          </div>
        ),
        cashier: s.lastCashier,
        totalInvoiceQty: (
          <div className="d-grid tx-upp fw-5 fs-14">
            <span>Qty: {s.totalInvoices}</span>
            <span>Invoices: {s.totalInvoices}</span>
          </div>
        ),
        totalSales: `${settings.curSymbol} ${s.totalSales.toFixed(
          settings?.decimal
        )}`,

        methods: s.paymentsByMethod
          .map(
            (p) =>
              `${p.method}: ${settings?.curSymbol} ${p.amount.toFixed(
                settings?.decimal
              )}`
          )
          .join(" | "),
      })),
    ]);

    return () => {};
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [reports]);

  const HeaderComp = () => (
    <div className="d-flex flex-wrap g-8 w-100pr">
      <span className="border-left tx-upp fw-5 fs-18 ml-5 gray-color">
        {pageTitle}
      </span>
    </div>
  );

  return (
    <>
      <DynamicTable
        records={tblData}
        setRecords={setReports}
        endpointKey={controller.Report + action.SalesGroupByCustomer}
        exportEndpoint={controller.Report + action.ExportSalesGroupByCustomer}
        ActionComp={() => <></>}
        HeaderComp={HeaderComp}
        enableExport={true}
        enableDateRange={true}
        showDefaultDate={true}
        defaultDate={{
          fromDate: dayjs().add(-1, "day"),
          toDate: dayjs().add(1, "day"),
        }}
        setResult={setResult}
        headers={[
          { id: "customer", label: t("customer") },
          { id: "cashier", label: t("lastCashier") },
          { id: "totalInvoiceQty", label: t("totalInvoiceQty") },
          { id: "totalSales", label: t("totalSales") },
          { id: "methods", label: t("paymentMethods") },
        ]}
        FooterRow={() => (
          <>
            <TableCell size="small">
              <span className="fs-18 fw-6 tx-upp gray-color"> Total</span>
            </TableCell>
            <TableCell size="small"></TableCell>
            <TableCell size="small">
              <div className="d-grid tx-upp fw-5 fs-14">
                <span>Qty: {result?.accounts?.totalItems}</span>
                <span>Invoices: {result?.accounts?.totalInvoice}</span>
              </div>
            </TableCell>
            <TableCell size="small" sx={{ minWidth: "130px" }}>
              <span className="fs-18 fw-6 tx-upp gray-color">
                {settings?.curSymbol} {result?.accounts?.totalSales}
              </span>
            </TableCell>
            <TableCell size="small"></TableCell>
          </>
        )}
      />
    </>
  );
};

export default SalesByCustomer;
